import { Outlet } from "react-router-dom";

export function PaddedLayout() {
  return (
    <div className="tw:flex-1 tw:flex tw:flex-col tw:overflow-y-auto tw:p-4 tw:min-h-0">
      <Outlet />
    </div>
  );
}
